function QuotePanel({ quote }) {
  return (
    <aside className="rounded-lg border-l-2 border-museum-gold bg-museum-black/50 p-6">
      <p className="font-display text-2xl leading-9 text-museum-bone">“{quote}”</p>
    </aside>
  );
}

export default QuotePanel;
